import CheckoutList from "@/controllers/checkout/checkout-list.js";

export default {
  extends: CheckoutList,
}
